import React, { HTMLAttributes } from 'react';

import {
  DesignSystemUserAvatarSize,
  getAvatarClasses,
  getAvatarInitials,
} from './utils';

type Props = Omit<HTMLAttributes<HTMLSpanElement>, 'children'> & {
  name: string;
  src?: string;
  alt?: string;
  size?: DesignSystemUserAvatarSize;
};

export const UserAvatar = ({
  name,
  src,
  alt,
  size = DesignSystemUserAvatarSize.MEDIUM,
  className,
  ...props
}: Props): JSX.Element => {
  const fallbackLabel = name || 'User';

  return (
    <span
      className={getAvatarClasses({ size, hasImage: Boolean(src), className })}
      {...(!src
        ? {
            role: 'img',
            'aria-label': fallbackLabel,
          }
        : {})}
      {...props}
    >
      {src ? (
        <img src={src} alt={alt || `${fallbackLabel} avatar`} />
      ) : (
        <span aria-hidden="true">{getAvatarInitials(name)}</span>
      )}
    </span>
  );
};

export type { Props as UserAvatarProps };
